<template>
  <card id="graph" class="new-past-months-graph-card" :class="{'out-of-date': outOfDate}">
    <template v-slot:header v-if="!outOfDate">
      <div class="header">
        <tiny-share-button class="card-share-button" :share-component="shareComponent" :share-component-props="shareComponentProps"
                           share-name="ShareEomGraph" filename="month-graph" :create-impression-on-click="true"></tiny-share-button>
      </div>
    </template>
    <div class="past-months-graph-content">
      <div class="title">{{ this.formattedTitle }}</div>
      <past-months-bar-graph :bar-values="barValues" :out-of-date="outOfDate"></past-months-bar-graph>
    </div>
  </card>
</template>

<script>
import _ from 'lodash';
import BaseUI from 'base-ui';
import moment from 'moment';
import { mapGetters, mapState } from 'vuex';
import TinyShareButton from '@/base-components/share/TinyShareButton';
import PastMonthsGraphAsset
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/past-editable-month/components/PastMonthsGraphAsset';
import PastMonthsBarGraph
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/past-editable-month/components/PastMonthsBarGraph';

const MONTHS_LENGTH = 5;

export default {
  name: 'PastMonthsGraph',
  components: {
    Card: BaseUI.Card,
    PastMonthsBarGraph,
    TinyShareButton,
  },
  props: {
    outOfDate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('cashflowView', ['monthName', 'cashflowGraphHistory', 'balance']),
    ...mapState('cashflowView', ['presentedBudgetDate']),
    formattedTitle() {
      return `${this.monthName} ביחס לחודשים אחרים`;
    },
    barValues() {
      const filledCashflowHistory = _padWithEmptyMonths(this.cashflowGraphHistory);
      return _.map(filledCashflowHistory, ({ total, cashflowDate }) => {
        return {
          cssClasses: {
            current: cashflowDate === this.presentedBudgetDate,
          },
          name: this.formatMonthName(cashflowDate),
          value: total,
        };
      });
    },
    graphHeight() {
      return 102;
    },
    shareComponent() {
      return PastMonthsGraphAsset;
    },
    shareComponentProps() {
      return {
        barValues: this.barValues,
      };
    },
  },
  methods: {
    formatMonthName(budgetDate) {
      return moment(budgetDate).locale('he').format('MMM');
    },
  },
};

function _padWithEmptyMonths(cashflowHistory) {
  const oldestCashflow = _.last(_.map(cashflowHistory, ({ cashflowDate }) => cashflowDate));
  const emptyPlaceholderMonths = _.times(MONTHS_LENGTH, i => {
    return { cashflowDate: moment(oldestCashflow).subtract(i + 1, 'month').format('YYYY-MM'), total: 0 };
  });
  return [...cashflowHistory, ...emptyPlaceholderMonths].slice(0, MONTHS_LENGTH);
}
</script>

<style lang="scss">
@import "~base-ui/src/scss/riseup-colors";
@import '../../../../../../../../scss/mixins';

.new-past-months-graph-card {
  padding-top: 10px;

  .title {
    @include cashflow-card-title;
  }

  &.out-of-date {
    .title {
      color: $riseup_gray_2;
    }
  }

  .header {
    text-align: left;
    margin: 0 -14px;
  }
}
</style>
